// extracted by mini-css-extract-plugin
export var createdDate = "_hc-1";
export var divider = "_hc-2";
export var headerDivider = "_hc-3";
export var messagesCard = "_hc-0";
export var messagesContainer = "_hc-7";
export var messagesContainerWrapper = "_hc-4";
export var pointerCapturingButtonBoxes = "_hc-a";
export var showLeftPanelButton = "_hc-9";
export var showMoreButton = "_hc-c";
export var showMoreButtonContainer = "_hc-b";
export var summaryTitle = "_hc-6";
export var systemMessageCardWrapper = "_hc-d";
export var topButtons = "_hc-8";
export var withPadding = "_hc-5";